import { gql } from "@apollo/client";

export const LIST_HOMEOWNER_CLIENTS = gql`
  query ListHomeownerClients($first: Int, $after: String) {
    listHomeowners(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          userId
          firstName
          lastName
          email
          phoneNumber
          createdAt
          clientProfile {
            id
            ownerType
            createdAt
          }
        }
      }
    }
  }
`;

export const GET_HOMEOWNER_CLIENT = gql`
  query GetHomeownerClient($id: String!) {
    homeowner(id: $id) {
      id
      userId
      firstName
      lastName
      email
      phoneNumber
      createdAt
      updatedAt
      clientProfile {
        id
        ownerType
        createdAt
        updatedAt
      }
      billingAddress {
        id
        address
        city
        state
        formattedAddress
      }
      addresses {
        id
        address
        city
        state
        formattedAddress
      }
    }
  }
`;

export const LIST_ORGANISATION_CLIENT_PROFILES = gql`
  query ListOrganisationClientProfiles($first: Int, $after: String) {
    organizationClientProfiles(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          contactName
          contactEmail
          contactPhoneNumber
          billingName
          createdAt
          organization {
            id
            name
          }
          clientProfile {
            id
            ownerType
            createdAt
          }
        }
      }
    }
  }
`;

export const GET_ORGANISATION_CLIENT_PROFILE = gql`
  query GetOrganisationClientProfile($id: String!) {
    organizationClientProfile(id: $id) {
      id
      contactUserId
      contactName
      contactEmail
      contactPhoneNumber
      billingName
      createdAt
      updatedAt
      organization {
        id
        name
        referralCode
        countryCode
        createdAt
      }
      clientProfile {
        id
        ownerType
        createdAt
        updatedAt
      }
      legacyClient {
        id
        userId
        firstName
        lastName
        email
        phoneNumber
      }
      billingAddress {
        id
        address
        city
        state
        formattedAddress
      }
    }
  }
`;
